import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const IBHOFLA_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/ibhofla/logo.png",
        alt: "Integrated Behavioral Health Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "180px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 31,
  state: "LA",
  departmentIds: [110, 134],
};
